import { ref } from 'vue';

import { fetchWebsocketUrl } from '@/api/apiService';
import { ConnectionInfo } from '@/types/socket';
import { CREATE_CHAT_TYPES } from '@/utils/constants/chat';

const LOCAL_SOCKET_BASE_URL = import.meta.env.VITE_SOCKET_BASE_URL;

const SOCKET_BASE_URL = import.meta.env.DEV ? 'wss://dev-soma.sconai.com/ws' : 'wss://soma.sconai.com/ws';

export default function useWebSocketUrl() {
  const webSocketUrl = ref<string>(SOCKET_BASE_URL);

  const requestWebsocketUrl = async (connectInfo: ConnectionInfo) => {
    if (LOCAL_SOCKET_BASE_URL) {
      webSocketUrl.value = LOCAL_SOCKET_BASE_URL;
      return;
    }

    try {
      const params = CREATE_CHAT_TYPES.includes(connectInfo.callType) ? { code: connectInfo.code } : {};
      const res = await fetchWebsocketUrl(params);
      if (!res.success || !res.data) {
        throw new Error();
      }
      webSocketUrl.value = res.data;
    } catch {
      webSocketUrl.value = SOCKET_BASE_URL;
    }
  };

  return {
    webSocketUrl,
    requestWebsocketUrl,
  };
}
